import "./partnerMainInformation.scss";

import { IPartnerBenefit } from "@src/api/partner/partner";

import PartnerSummary from "./PartnerSummary";
import PartnerBenefits from "./PartnerBenefits";
import { Badge } from "../weddingHall/home/HomeHallCard";
import { addComma } from "@src/utils";


type pageType = 'partner' | 'weddinghall';
export default function PartnerMainInformation(props: {
  type: pageType;
  partnerName: string;
  summaries: {
    iconUrl: string;
    textArr: string[];
  }[];
  benefits: IPartnerBenefit[];
  comparisonClassNames?: {
    bizName?: string;
    specialFeatures?: string;
    benefits?: string;
  };
  productBtn?:{name: string;func: (idx: number) => void;}| null;// 잔여타임 이동 버튼
  price?:{discountRate:number;minPrice:number;totalAmount:number;}; //웨딩홀 가격 정보
  badges?:string[]; // 웨딩홀 뱃지
}) {

  return (
    <div className="partner-main-information-wrap">
      {props.badges && props.badges.length > 0 && (
					<div className="badge-wrap">
						{props.badges.map((badge) => (
							<Badge text={badge} key={`hall-list-badge-${badge}`} />
						))}
					</div>
				)}
      <h2 className={`partner-name ${props.comparisonClassNames?.bizName}`}>{props.partnerName}</h2>

      <div className={`${props.comparisonClassNames?.specialFeatures}`}>
        <PartnerSummary summaries={props.summaries} />
      </div>

      {props.type === 'weddinghall' && !!props.price &&
      <div className={`hall-price`} style={{alignItems: 'center'}}> {/** 가격 정책 정립 전까지 최저가만 표시, 스타일 추후 삭제 */}
        <div>
          {/* {props?.price?.totalAmount !== props?.price?.minPrice && <p className="total-price">{addComma(props?.price?.totalAmount)}원 ~</p>} */}
          <p className="discount bold">
            {/* <span>{props?.price?.discountRate > 0 && `${props?.price?.discountRate}% `}</span> */}
            {(props?.price.minPrice > 0) ? addComma(props?.price?.minPrice) : addComma(props.price.totalAmount)}원~
          </p>
        </div>
        {props.productBtn !== null &&
        <button 
          className="btn btn-medium btn-outline-gray200"
          onClick={()=>props?.productBtn?.func(2)}>
            {props?.productBtn?.name}
        </button>}
      </div>}

      <div className={`${props.comparisonClassNames?.benefits}`}>
        <PartnerBenefits benefits={props.benefits} />
      </div>
    </div>
  );
}
